import { isIos } from "@/utils/parserDevice";
type ScrollElement = Element | Window;

function trimExtraChar(value: string, char: string, regExp: RegExp) {
	const index = value.indexOf(char);

	if (index === -1) {
		return value;
	}

	if (char === "-" && index !== 0) {
		return value.slice(0, index);
	}

	return value.slice(0, index + 1) + value.slice(index).replace(regExp, "");
}

export function formatNumber(value: string, allowDot = true, allowMinus = true): string {
	if (allowDot) {
		value = trimExtraChar(value, ".", /\./g);
	} else {
		value = value.split(".")[0];
	}

	if (allowMinus) {
		value = trimExtraChar(value, "-", /-/g);
	} else {
		value = value.replace(/-/g, "");
	}

	const regExp = allowDot ? /[^-0-9.]/g : /[^-0-9]/g;

	return value.replace(regExp, "");
}

export function resetScroll(): void {
	if (isIos()) {
		setRootScrollTop(getRootScrollTop());
	}
}

export function getRootScrollTop(): number {
	return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
}

export function setScrollTop(el: ScrollElement, value: number): void {
	if ("scrollTop" in el) {
		el.scrollTop = value;
	} else {
		el.scrollTo(el.scrollX, value);
	}
}

export function setRootScrollTop(value: number): void {
	setScrollTop(window, value);
	// setScrollTop(document.body, value);
}
